import React from 'react';

interface TechtonAttributionProps {
  className?: string;
  textColor?: string;
  accentColor?: string;
}

/**
 * TechtonAttribution - A reusable "Powered by Techton" widget
 * 
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.textColor] - Color for the "Powered By" text (default: "text-white")
 * @param {string} [props.accentColor] - Color for the "Techton" text (default: "text-cyan-400")
 * 
 * @example
 * // Basic usage
 * <TechtonAttribution />
 * 
 * // With custom colors
 * <TechtonAttribution textColor="text-gray-200" accentColor="text-blue-400" />
 */
export const TechtonAttribution: React.FC<TechtonAttributionProps> = ({
  className = '',
  textColor = 'text-white',
  accentColor = 'text-cyan-400'
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <span className={`font-medium ${textColor}`}>Powered By</span>
      <a 
        href="https://techton.cloud/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className={`ml-2 ${accentColor} font-bold hover:opacity-80 transition-opacity duration-300 bg-slate-800/50 px-3 py-1 rounded-lg border border-cyan-500/30 shadow-lg shadow-cyan-500/10`}
      >
        Techton
      </a>
    </div>
  );
};

// Usage examples:
// 
// 1. Basic usage:
// import { TechtonAttribution } from './components/TechtonAttribution';
//
// function App() {
//   return (
//     <footer>
//       <TechtonAttribution />
//     </footer>
//   );
// }
//
// 2. Custom styling:
// <TechtonAttribution 
//   className="justify-center my-4" 
//   textColor="text-gray-200" 
//   accentColor="text-blue-500" 
// />